export default "__VITE_ASSET__47b04180__"